import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PT from 'prop-types';
import { intrinsicComponent, objectValues } from '../../utils/functions';
import { InputSize } from '../../utils/types';
import Styled from './form-hint.styles';
var FormHint = intrinsicComponent(function (props, ref) {
  return /*#__PURE__*/React.createElement(Styled.FormHint, _extends({
    ref: ref
  }, props));
});
FormHint.defaultProps = {
  error: false
};
FormHint.propTypes = {
  error: PT.bool,
  size: PT.oneOf(objectValues(InputSize))
};
export default FormHint;